import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TxnCat } from 'src/app/shared/services/bank-accounts.categories';
import { BankAccountsService, EnrichmentRule, EnrichmentRuleAction, EnrichmentRuleActionExpressionCategory, EnrichmentRuleActionExpressionIncome, EnrichmentRuleset, INCOME_TYPES, TRANSACTION_TYPES } from 'src/app/shared/services/bank-accounts.service';

@Component({
  selector: 'app-enrichment-ruleset-list-rules',
  templateUrl: './enrichment-ruleset-list-rules.component.html',
  styleUrls: ['./enrichment-ruleset-list-rules.component.scss']
})
export class EnrichmentRulesetListRulesComponent {
  rulesColumnsDisplay: string[] = ["ruleDesc", "ruleActionList", "actions"];
  ruleset: EnrichmentRuleset = new EnrichmentRuleset();
  isSaving: boolean = false;

  @ViewChild(MatTable)
  table!: MatTable<EnrichmentRule>;


  constructor(private bankAccSvc: BankAccountsService, private router: Router, private activatedRoute: ActivatedRoute, breakpointObserver: BreakpointObserver, private formBuilder: FormBuilder, private _snackBar: MatSnackBar) {
    let state = this.router.getCurrentNavigation()?.extras.state;
    console.log(state);
    if (state && state['ruleset']) {
      this.ruleset = state['ruleset'] as EnrichmentRuleset;
    }
  }

  onClickSave(): void {
    this.isSaving = true;
    if(this.ruleset && this.ruleset.Id) {
      this.bankAccSvc.udpateRuleset(this.ruleset)
        .subscribe({
          next: (data) => {
            this.ruleset = data;
            this.isSaving = false;
            this.router.navigate(['/bank/accounts/enrichment/rulesets']);
          },
          error: (err) => {
            this.isSaving = false;
            this._snackBar.open("Error occured saving your changes, please try again later.", undefined, { duration: 5000 })
          }
        });
    }
  }

  onClickDelete(ruleIndex: number): void {
    console.log("remove rule: " + ruleIndex);
    if(this.ruleset && this.ruleset.Rules && this.ruleset.Rules[ruleIndex]) {
      this.ruleset.Rules.splice(ruleIndex, 1);
      this.table.renderRows();
      console.log(this.ruleset);
    }
  }

  onClickCancel(): void {
    this.router.navigate(['/bank/accounts/enrichment/rulesets']);
  }

  printRule(rule: EnrichmentRule): string {
    let result = "";
    switch (rule.RuleType) {
      case 'exactMatch':
        result = result + "Description equals";
        break;
      case 'beginsWith':
        result = result + "Description begins with";
        break;
      case 'contains':
        result = result + "Description contains";
        break;
      case 'regEx':
        result = result + "Description regular expression";
        break;

      default:
        break;
    }

    result = result + ' "' + rule.RuleExpression + '"';

    return result;
  }

  printAction(action: EnrichmentRuleAction): string {
    let result = "";

    switch (action.ActionType) {
      case "applyCategory":
        result = result + "Apply category";
        var cat = JSON.parse(action.ActionExpression as string) as EnrichmentRuleActionExpressionCategory;
        if (cat) {
          result = result + ' "' + cat.CategoryText + '"';
        }
        break;

      case "applyTag":
        result = result + "Apply tag " + '"' + action.ActionExpression + '"';
        break;

      case "isIncome":
        result = result + "Set as Income"
        var inc = JSON.parse(action.ActionExpression as string) as EnrichmentRuleActionExpressionIncome;
        if(inc) {
          result = result + ' : "' + (INCOME_TYPES[inc.IncomeType as string] ? INCOME_TYPES[inc.IncomeType as string] : 'unknown type') + '"';
          result = result + " from " + '"' + inc.Name as string + '"';
        }
        break;

      case "setTransactionType":
        result = result + "Set transaction type to " + '"' + (TRANSACTION_TYPES[action.ActionExpression as string] ? TRANSACTION_TYPES[action.ActionExpression as string] : 'Unknow') + '"';
        break;

      default:
        break;
    }
    return result;
  }
}
